<div class="shop">
  <div class="shopHeader">
    <div class="p-4 container text-center">
      <div>
        <img class="shopSellerImage" src="{{businessData?.logo ? businessData.logo : '../../../../../assets/images/background/invoice.jpg'}}" />
      </div>
      <h1 class="text-white font-weight-bolder">{{ businessData?.name }}</h1>
    </div>
  </div>

  <div class="p-2 mb-4 w-100 shopBigSeparator"></div>

  <div class="container">
    <div class="text-center border-bottom pb-2 mb-4">
      <h2>{{ 'Buyer.About' | translate }}</h2>
      <p>{{ businessData?.description }} </p>
    </div>

    <div class="text-center" *ngIf="_products && _products.length">
      <h2 class="mb-3">{{ 'Buyer.AllProducts' | translate }}</h2>
      <div class="row justify-content-center">
        <!-- A single product. -->
        <div *ngFor="let product of _products" class="col-md-12 col-lg-3 p-3">
          <div (click)="openProduct(product.code)" class="shopSingleProductWrapper">
            <div class="shopSingleProductType">{{ product.productType }}</div>
            <div class="shopSingleProduct">
              <div [ngStyle]="{ 'background-image': 'url(' + product.image + ')'}" class="shopSingleProductImage"></div>
              <div class="p-2">
                <div class="mb-2 shopSingleProductButton">
                  <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="chevron-right"
                        role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                    <path d="M285.476 272.971L91.132 467.314c-9.373 9.373-24.569 9.373-33.941 0l-22.667-22.667c-9.357-9.357-9.375-24.522-.04-33.901L188.505 256 34.484 101.255c-9.335-9.379-9.317-24.544.04-33.901l22.667-22.667c9.373-9.373 24.569-9.373 33.941 0L285.475 239.03c9.373 9.372 9.373 24.568.001 33.941z"></path>
                  </svg>
                </div>
                <div class="text-center">
                  <div class="fs-6 font-weight-bold">{{ product.productName }}</div>
                  <div class="font-weight-bold shopSingleProductExtraInfo">{{ product.productPrice ? product.productPrice + ' ' + product.currency : ''}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
